import { PixelPlaceholderLoader, TitlePlaceholderLoader } from "@similarweb/ui-components";
import { LOADER_ROWS_COUNT } from "./const";
import { StyledResultsLoaderRow, StyledTitleItem, StyledView } from "./styles";

type Props = {
    rowsCount?: number;
};

const ResultsLoader = ({ rowsCount = LOADER_ROWS_COUNT }: Props) => {
    return (
        <StyledView data-automation="results-loader-view">
            {Array.from({ length: rowsCount }).map((_, index) => (
                <StyledResultsLoaderRow key={index}>
                    <StyledTitleItem>
                        <PixelPlaceholderLoader
                            width={32}
                            height={32}
                        />
                        <TitlePlaceholderLoader />
                    </StyledTitleItem>

                    <PixelPlaceholderLoader
                        width={44}
                        height={14}
                    />
                    <PixelPlaceholderLoader
                        width={44}
                        height={14}
                    />
                </StyledResultsLoaderRow>
            ))}
        </StyledView>
    );
};

export default ResultsLoader;
